import { useEffect, useState } from "react";
import { Shuffle, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { drawQuestions } from "@/lib/questionDraw";

const VARIANT = { simple: "Unique", positive: "Principale", negative: "Inverse" };

export const DrawPreview = ({ vary, refreshKey }) => {
  const [questions, setQuestions] = useState(null);
  const [draw, setDraw] = useState([]);
  useEffect(() => {
    api.get("/referentials").then((r) => setQuestions(r.data.questions.filter((q) => q.active !== false))).catch(() => setQuestions([]));
  }, [refreshKey]);
  useEffect(() => { if (questions) setDraw(drawQuestions(questions, vary)); }, [questions, vary]);
  if (!questions) return null;
  return (
    <div className="mb-5 rounded-lg border border-border bg-card p-4" data-testid="take5-draw-preview">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-semibold"><Eye className="h-4 w-4 text-amber-500" /> Aperçu d'un Take 5</p>
        {vary && <Button size="sm" variant="outline" data-testid="take5-draw-preview-shuffle" onClick={() => setDraw(drawQuestions(questions, true))}><Shuffle className="mr-1 h-4 w-4" /> Nouveau tirage</Button>}
      </div>
      <p className="mt-1 text-xs text-muted-foreground">Exemple de ce que verra l'opérateur{vary ? " : chaque Take 5 reçoit son propre tirage, figé jusqu'à la fin." : "."} Aucun Take 5 n'est créé.</p>
      {!draw.length && <p className="mt-3 text-sm text-muted-foreground">Aucune question active.</p>}
      <ol className="mt-3 space-y-2">
        {draw.map((q, i) => (
          <li key={q.id} data-testid={`take5-draw-preview-${i + 1}`} className="flex items-start justify-between gap-3 rounded-md border border-border p-3 text-sm">
            <span className="min-w-0"><span className="mr-2 font-data text-amber-500">{i + 1}.</span>{q.text}
              <span className="ml-2 text-xs text-muted-foreground">({VARIANT[q.variant]})</span></span>
            <span data-testid={`take5-draw-preview-${i + 1}-answer`} className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-bold ${q.safe_answer === "oui" ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300" : "bg-sky-500/15 text-sky-700 dark:text-sky-300"}`}>
              Attendu : {q.safe_answer.toUpperCase()}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};
